<div class="footer flex">
  <div class="footer_top">
    <div class="footer_main">
      <a [href]="'/'" class="footer_img__link">
        <img class="footer_img pointer" src="../../../assets/logo/JUSTSEXT.svg" alt="logo" />
      </a>
      <p class="footer_text">
        JustSext has all your favorite creators one text away, ready to chat. Instantly chat, get
        custom images, voice notes, and more from AI personas modelled after top creators you know
        and love.
      </p>
      <div class="footer_socials">
        <a [href]="instagramUrl" target="_blank">
          <stxt-svg-icon [iconConfig]="instagramSvg" class="footer_socials-icon" />
        </a>
        <a [href]="xUrl" target="_blank">
          <stxt-svg-icon [iconConfig]="xSvg" class="footer_socials-icon" />
        </a>
      </div>
    </div>
    <div class="footer_nav">
      <div class="footer_nav__resources">
        <p class="footer_nav__title">Resources</p>
        <ul class="footer_nav__list">
          <li *ngFor="let footerLink of footerLinks" class="footer_nav__list-item">
            <a [href]="footerLink.url" target="_blank">{{ footerLink.title }}</a>
          </li>
        </ul>
      </div>
      <div class="footer_stxt-info">
        <div *ngFor="let stxtLink of stxtLinks" class="footer_nav__list-item">
          <p class="footer_nav__title">{{ stxtLink.header }}</p>
          <a class="footer_nav__item" [href]="stxtLink.url" target="_blank">{{ stxtLink.title }}</a>
        </div>
      </div>
    </div>
  </div>
  <div class="divider"></div>
  <div class="footer_bottom">
    <div class="flex payment-method_cards">
      <ng-container *ngFor="let paymentMethod of availablePayments">
        <img
          class="payment-method_card"
          src="/assets/d2c-images/{{ paymentMethod }}.svg"
          alt="{{ paymentMethod }}"
        />
      </ng-container>
    </div>
    <p class="footer_rights">
      © 2025 Synthetic Turing Experience Technologies. All rights Reserved.
    </p>
  </div>
</div>
